<template>
  <div class="list-wrap">
    <tag-item
      :tag="allTags[tag.id] || tag"
      :resourceId="resourceId"
      v-for="tag in tags"
      :key="tag.id"
      @click="t => $emit('tagClicked', t)"
      :contextOptions="contextOptions"
      v-bind="tagProps"
    ></tag-item>

    <slot name="afterTags"></slot>
  </div>
</template>

<script>
import TagItem from "@/shared/components/tag/Item";

export default {
  props: {
    tags: {
      type: [Array, Object]
    },
    resourceId: {
      type: [Number, String],
      default: null
    },
    contextOptions: {
      type: Object,
      default: () => ({})
    },
    tagProps: {
      type: Object,
      default: () => ({})
    },
  },

  computed: {
    allTags() {
      return this.$store.getters[`${this.currentContext}/tags`];
    }
  },

  components: {
    TagItem
  }
}
</script>

<style lang="scss" scoped>
.list-wrap {
  display: flex;
  flex-wrap: wrap;
}
</style>